import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createBillingActions } from './actions';
import { BillingActions, BillingState } from './types';

export const useBillingStore = create<BillingState & BillingActions>()(
    immer((set, get, store) => ({
        snapshot: null,
        loading: false,
        mutating: false,
        error: undefined,
        lastFetchedAt: undefined,
        _inflightFetch: undefined,
        ...createBillingActions(set, get, store),
    })),
);
